import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createClientProfileLink, deleteClientProfileLink } from "../../../../lib/api";

export function useClient360ProfileLinks(profileId: string) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ action, note, relatedProfileId }: {
            action: "create" | "delete";
            note?: string;
            relatedProfileId: string;
        }) => (
            action === "create"
                ? createClientProfileLink({ profileId, relatedProfileId, note })
                : deleteClientProfileLink({ profileId, relatedProfileId })
        ),
        onSuccess: async () => {
            await Promise.all([
                queryClient.invalidateQueries({ queryKey: ["client-360-history", profileId] }),
                queryClient.invalidateQueries({ queryKey: ["client-360-profile", profileId] }),
            ]);
        },
    });
}
